import {
    Component,
    OnInit,
    Inject,
    ViewChild,
    AfterViewInit,
    HostListener,
    ElementRef,
    EventEmitter
} from '@angular/core';
import { LoginSettings } from '../../../shared-modules/login/LoginSetting.model';
import { Year } from '../../../shared-components/year/year.model';
import { Subscription } from 'rxjs';
import { LoginService } from '../../../shared-modules/login/login.service';
import { YearService } from '../../../shared-components/year/year.service';
import { UserService } from '../../../shared-components/user/user.service';
import { User } from '../../../shared-components/user/user.model';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MassEmail, Recipient, StudentContact, MassEmailStudent } from '../mass-email.model';
import { TylerMatTableDataSource } from '../../../shared-components/angular-material/extended.class';
import { detailExpand } from '../../../shared-components/angular-material/mat-animations';
import { ErrorList } from '../../../shared-components/controls/error-prompt/error-list.model';
import { MassEmailService } from '../mass-email.service';
import { UnselectedWarningComponent } from '../unselected-warning/unselected-warning.component';
import { NoEmailWarningComponent } from '../no-email-warning/no-email-warning.component';
import { FormControl } from '@angular/forms';
import * as _ from 'lodash';
import { ClassroomSummary } from '../../../classroom360/classroom-summary/models/classroom-summary.model';
import { StudentTeams } from '../../../classroom360/student-teams/student-teams.model';
import { StudentList } from '../../../classroom360/student-lists/student-list.model';

@Component({
    selector: 'app-select-recipients',
    templateUrl: './select-recipients.component.html',
    animations: [detailExpand],
})
export class SelectRecipientsComponent implements OnInit, AfterViewInit {
    loginSettings = new LoginSettings();
    defaultYear: Year;
    defaultYearSubscription: Subscription;
    currentUser: User;
    tabIndex = new EventEmitter<number>();
    massEmail: MassEmail;
    tabNames: string[] = ['Class View', 'Student View', 'Additional'];
    selectedTab: string;
    columnsToDisplayInClassView = ['More', 'Select', 'Course', 'SubjectCode', 'Section', 'Term', 'HomeRoom'];
    columnsToDisplayInDetailClassView = ['Select', 'StudentNumber', 'Name', 'GradeLevel', 'Email'];
    columnsToDisplayInStudentView = ['Select', 'StudentNumber', 'Name', 'GradeLevel', 'Email', 'Course'];
    selectedClasses: ClassroomSummary[] = [];
    selectedStudents: MassEmailStudent[] = [];
    selectedClassesCheckAll: boolean;
    classViewDataSource = new TylerMatTableDataSource();
    studentViewDataSource = new TylerMatTableDataSource();
    errorList: ErrorList[] = [];
    error: ErrorList;
    massEmailErrorCount: number;
    retValSelectRecipient: any = {};
    retMessage: string;
    householdParentLabel: string;
    test = [];
    contactTypes = new FormControl();
    selectedContactType: string[];


    // Student Team
    columnsToDisplayInTeamView = ['More', 'Select', 'TeamName'];
    selectedTeamsCheckAll: boolean;
    teamViewDataSource = new TylerMatTableDataSource();
    selectedStudentTeams: StudentTeams[] = [];
    @ViewChild('tvSort') tvSort: MatSort;

    // Student List
    columnsToDisplayInListView = ['More', 'Select', 'ListName'];
    selectedListsCheckAll: boolean;
    listViewDataSource = new TylerMatTableDataSource();
    selectedStudentLists: StudentList[] = [];
    @ViewChild('lvSort') lvSort: MatSort;

    @ViewChild('svSort') svSort: MatSort;
    @ViewChild('cvSort') cvSort: MatSort;
    @ViewChild('pageHeader', { static: true }) pageHeader: ElementRef;
    @ViewChild('tblControls') tblControls: ElementRef;
    @ViewChild('tab') tab: ElementRef;
    @ViewChild('pageFooter', { static: true }) pageFooter: ElementRef;
    @ViewChild('mergeName') mergeName: ElementRef;
    pageHeaderHeight: number;
    tblControlsHeight: number;
    tabHeight: number;
    pageFooterHeight: number;
    gridHeight: number;
    unselectedWarningDialogRef: MatDialogRef<UnselectedWarningComponent>;
    noEmailWarningDialogRef: MatDialogRef<NoEmailWarningComponent>;
    v10: boolean;
    constructor(
        private loginService: LoginService,
        private yearService: YearService,
        private userService: UserService,
        private massEmailService: MassEmailService,
        public selectRecipientDialogRef: MatDialogRef<SelectRecipientsComponent>,
        @Inject(MAT_DIALOG_DATA) public massEmailObj: MassEmail,
        private dialog: MatDialog,
        private dialogBox: MatDialogRef<SelectRecipientsComponent>
    ) {  }

    ngOnInit() {
        this.defaultYear = this.yearService.defaultYear;
        this.defaultYearSubscription = this.yearService.observableDefaultYearStream$.subscribe(
            defaultYear => {
                this.defaultYear = defaultYear;
            }
        );
        this.massEmail = this.massEmailObj;
        this.v10 = this.loginService.LoginSettings.V10;
        if (this.massEmail.StudentIds.length > 0) {
            this.getStudentInfoForMassEmail();
        } else {
            this.initialize();
        }

    }

    initialize() {
        this.selectedTab = 'Class View';
        this.currentUser = this.userService.currentUser;
        this.loginSettings = new LoginSettings();
        this.loginSettings = this.loginService.LoginSettings;
        if (this.massEmail.ReferringPage == 'My Classes') {
            this.columnsToDisplayInStudentView = ['Select', 'StudentNumber', 'Name', 'GradeLevel', 'Email', 'Course'];
        }
        if (this.massEmail.ReferringPage == 'Student Teams') {
            this.columnsToDisplayInStudentView = ['Select', 'StudentNumber', 'Name', 'GradeLevel', 'Email', 'Team'];
        }
        if (this.massEmail.ReferringPage == 'Student Lists') {
            this.columnsToDisplayInStudentView = ['Select', 'StudentNumber', 'Name', 'GradeLevel', 'Email', 'List'];
        }
        if (
            this.massEmail.ReferringPage == 'Attendance'
            || this.massEmail.ReferringPage == 'Student Search'
        ) {
            this.columnsToDisplayInStudentView = ['Select', 'StudentNumber', 'Name', 'GradeLevel', 'Email'];
        }
        this.selectedStudents = this.massEmail.Students;
        this.selectedClasses = this.massEmail.MassEmailClasses;
        this.selectedStudentTeams = this.massEmail.MassEmailStudentTeams;
        this.selectedStudentTeams.forEach(st => {
            st.IsSelectedForMassEmail = true;
        });

        this.selectedStudentLists = this.massEmail.MassEmailStudentLists;
        this.selectedStudentLists.forEach(lt => {
            lt.IsSelectedForMassEmail = true;
        });

        this.massEmail.selectedStudentsCheckAll = true;
        this.selectedClassesCheckAll = true;
        this.selectedTeamsCheckAll = true;
        this.selectedListsCheckAll = true;
        this.massEmail.SendEmailToTeachers = (this.massEmail.SendEmailToTeachers == null || this.massEmail.SendEmailToTeachers == undefined) ? false : this.massEmail.SendEmailToTeachers;
        this.massEmail.SendEmailToTeamStaffMembers = (this.massEmail.SendEmailToTeamStaffMembers == null || this.massEmail.SendEmailToTeamStaffMembers == undefined) ? false : this.massEmail.SendEmailToTeamStaffMembers;
        this.massEmail.StudentRecipientType = (this.massEmail.StudentRecipientType == null || this.massEmail.StudentRecipientType == undefined) ? '' : this.massEmail.StudentRecipientType;
        this.massEmail.HouseholdRecipientType = (this.massEmail.HouseholdRecipientType == null || this.massEmail.HouseholdRecipientType == undefined) ? '' : this.massEmail.HouseholdRecipientType;
        this.massEmail.NonHouseholdRecipientType = (this.massEmail.NonHouseholdRecipientType == null || this.massEmail.NonHouseholdRecipientType == undefined) ? '' : this.massEmail.NonHouseholdRecipientType;
        this.massEmail.IncludeAll = (this.massEmail.IncludeAll == null || this.massEmail.IncludeAll == undefined) ? false : this.massEmail.IncludeAll;
        if (this.loginSettings.MassEmailContactsGrouped == true) {
            this.householdParentLabel = 'Household Parents';
        } else {
            this.householdParentLabel = 'Students Contacts';
        }

        if (this.massEmail.ReferringPage == 'My Classes') {
            this.tabChange(0);
        }
        else if (this.massEmail.ReferringPage == 'Student Teams') {
            this.tabNames = ['Team View', 'Students', 'Additional'];
            this.tabChange(0);
        }
        else if (this.massEmail.ReferringPage == 'Student Lists') {
            this.tabNames = ['List View', 'Students', 'Additional'];
            this.tabChange(0);
        }
        else {
            this.tabNames = ['Students', 'Additional'];
            this.tabChange(0);
        }
        for (let n = 0; n < this.selectedStudents.length; n++) {
            if (!this.selectedStudents[n].IsSelected) {
                this.massEmail.selectedStudentsCheckAll = false;
            }
        }
        if (this.pageHeader != undefined) {
            this.pageHeaderHeight = this.pageHeader.nativeElement.offsetHeight;
        }
        if (this.tab && this.tab.nativeElement != undefined) {
            this.tabHeight = this.tab.nativeElement.offsetHeight;
        }
        if (this.tblControls != undefined) {
            this.tblControlsHeight = this.tblControls.nativeElement.offsetHeight;
        }
        if (this.pageFooter != undefined) {
            this.pageFooterHeight = this.pageFooter.nativeElement.offsetHeight;
        }
        this.classViewDataSource.expandAll(false);
        this.teamViewDataSource.expandAll(false);
        this.listViewDataSource.expandAll(false);
        this.selectedContactType = this.massEmail.SelectedContactTypes;

    }

    ngAfterViewInit() {
        this.resizeGrid();
    }

    loadDataTable() {
        this.classViewDataSource.data = [];
        this.teamViewDataSource.data = [];
        this.listViewDataSource.data = [];
        if (this.selectedTab == 'Class View') {
            for (let i = 0; i < this.selectedClasses.length; i++) {
                this.selectedClasses[i].Students = [];
                for (let j = 0; j < this.selectedStudents.length; j++) {
                    for (let k = 0; k < this.selectedStudents[j].SubjectSections.length; k++) {
                        if ((this.loginSettings.V10 && this.selectedStudents[j].SubjectSections[k] == this.selectedClasses[i].SSEC_ID) || (!this.loginSettings.V10 && this.selectedStudents[j].SubjectSections[k] == this.selectedClasses[i].Id)) {
                            this.selectedClasses[i].Students.push(this.selectedStudents[j]);
                        }
                    }
                }
            }
            this.classViewDataSource.data = this.selectedClasses;
            const tempSVdataSource: MassEmailStudent[] = [];
            this.studentViewDataSource.data = tempSVdataSource;
            setTimeout(() => this.classViewDataSource.sort = this.cvSort);
        }
        else if (this.selectedTab == 'Team View') {
            for (let i = 0; i < this.selectedStudentTeams.length; i++) {
                this.selectedStudentTeams[i].Students = [];
                for (let j = 0; j < this.selectedStudents.length; j++) {
                    for (let k = 0; k < this.selectedStudents[j].StudentTeams.length; k++) {
                        if (this.selectedStudents[j].StudentTeams[k] == this.selectedStudentTeams[i].Id) {
                            this.selectedStudentTeams[i].Students.push(this.selectedStudents[j]);
                        }
                    }
                }
            }
            this.teamViewDataSource.data = this.selectedStudentTeams;
            const tempSVdataSource: MassEmailStudent[] = [];
            this.studentViewDataSource.data = tempSVdataSource;
            setTimeout(() => this.teamViewDataSource.sort = this.tvSort);
        }
        else if (this.selectedTab == 'List View') {
            for (let i = 0; i < this.selectedStudentLists.length; i++) {
                this.selectedStudentLists[i].MassEmailStudents = [];
                for (let j = 0; j < this.selectedStudents.length; j++) {
                    for (let k = 0; k < this.selectedStudents[j].StudentLists.length; k++) {
                        if (this.selectedStudents[j].StudentLists[k] == this.selectedStudentLists[i].ID) {
                            this.selectedStudentLists[i].MassEmailStudents.push(this.selectedStudents[j]);
                        }
                    }
                }
            }
            this.listViewDataSource.data = this.selectedStudentLists;
            const tempSVdataSource: MassEmailStudent[] = [];
            this.studentViewDataSource.data = tempSVdataSource;
            setTimeout(() => this.listViewDataSource.sort = this.lvSort);
        }
        else {
            this.studentViewDataSource.data = this.selectedStudents;
            this.studentViewDataSource.sortingDataAccessor = (item: any, property: string) => {
                if (property == 'Course') {
                    return item['SubjectSections'];
                }
                //  Default sorting
                else {
                    return this.studentViewDataSource.defaultSortingAccessor(item, property);
                }
            };
            const tempCVdataSource: ClassroomSummary[] = [];
            this.classViewDataSource.data = tempCVdataSource;
            setTimeout(() => this.studentViewDataSource.sort = this.svSort);
        }
    }

    validate() {
        const studentsWithoutRecipients: MassEmailStudent[] = [];
        if (this.massEmail.Students.filter(x => x.IsSelected == true).length == 0) {
            this.error = new ErrorList();
            this.error.errorMsg = 'Either select at least one student or click Cancel to abandon the Mass Email process.';
            this.error.fieldName = '';
            this.error.fieldRef = null;
            this.errorList.push(this.error);
            this.massEmailErrorCount += 1;
        }
        if (!this.loginSettings.MassEmailContactsGrouped) { // v10
            if ((this.massEmail.StudentRecipientType == null || this.massEmail.StudentRecipientType == undefined || this.massEmail.StudentRecipientType == '') &&
                (this.massEmail.HouseholdRecipientType == null || this.massEmail.HouseholdRecipientType == undefined || this.massEmail.HouseholdRecipientType == '') &&
                (this.massEmail.SendEmailToTeachers == null || this.massEmail.SendEmailToTeachers == undefined || this.massEmail.SendEmailToTeachers == false) &&
                (this.massEmail.SendEmailToTeamStaffMembers == null || this.massEmail.SendEmailToTeamStaffMembers == undefined || this.massEmail.SendEmailToTeamStaffMembers == false)) {
                this.error = new ErrorList();
                this.error.errorMsg = 'Select at least one recipient group to whom the email should be sent.';
                this.error.fieldName = '';
                this.error.fieldRef = null;
                this.errorList.push(this.error);
                this.massEmailErrorCount += 1;
            } else if (this.massEmail.HouseholdRecipientType != null && this.massEmail.HouseholdRecipientType != '') {
                if (!this.selectedContactType) {
                    this.error = new ErrorList();
                    this.error.errorMsg = 'If BCC is checked, at least one Contact Type must be selected.';
                    this.error.fieldName = '';
                    this.error.fieldRef = null;
                    this.errorList.push(this.error);
                    this.massEmailErrorCount += 1;
                }
            }
        } else { // V9
            if (this.massEmail.ReferringPage == 'My Classes' || this.massEmail.ReferringPage == 'Student Teams' || this.massEmail.ReferringPage == 'Student Lists') {
                const fieldName: string = this.massEmail.ReferringPage == 'Student Teams' ? 'TeamViewTab' : this.massEmail.ReferringPage == 'Student Lists' ? 'ListViewTab' : 'ClassViewTab';
                if ((this.massEmail.StudentRecipientType == null || this.massEmail.StudentRecipientType == undefined || this.massEmail.StudentRecipientType == '' || this.massEmail.StudentRecipientType == 'Do Not Include') &&
                    (this.massEmail.HouseholdRecipientType == null || this.massEmail.HouseholdRecipientType == undefined || this.massEmail.HouseholdRecipientType == '' || this.massEmail.HouseholdRecipientType == 'Do Not Include') &&
                    (this.massEmail.NonHouseholdRecipientType == null || this.massEmail.NonHouseholdRecipientType == undefined || this.massEmail.NonHouseholdRecipientType == '' || this.massEmail.NonHouseholdRecipientType == 'Do Not Include') &&
                    (this.massEmail.SendEmailToTeachers == null || this.massEmail.SendEmailToTeachers == undefined || this.massEmail.SendEmailToTeachers == false)) {
                    this.error = new ErrorList();
                    this.error.errorMsg = 'Select at least one recipient group to whom the email should be sent.';
                    this.error.fieldName = fieldName;
                    this.error.fieldRef = null;
                    this.errorList.push(this.error);
                    this.massEmailErrorCount += 1;
                }
            }
        }
        if (Object.keys(this.massEmail.AdditionalRecipients).length > 0) {
            const additionalTabIndex = this.tabNames.indexOf('Additional');
            const re = new RegExp('^(([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9_\\-\\.]+)\\.([a-zA-Z]{2,5}){1,25}(($)|( *;+ *$)|( *;+ *(?=[a-zA-Z0-9_\\-\\.]))))*$');
            // Validate the email string
            if (this.massEmail.AdditionalRecipients['to'] && !re.test(this.massEmail.AdditionalRecipients.to)) {
                this.error = new ErrorList();
                this.error.errorMsg = 'One or more emails in the "To:" recipient field is invalid';
                this.error.fieldName = '';
                this.error.fieldRef = null;
                this.errorList.push(this.error);
                this.massEmailErrorCount += 1;
            }
            if (this.massEmail.AdditionalRecipients['cc'] && !re.test(this.massEmail.AdditionalRecipients.cc)) {
                this.error = new ErrorList();
                this.error.errorMsg = 'One or more emails in the "CC:" recipient field is invalid';
                this.error.fieldName = '';
                this.error.fieldRef = null;
                this.errorList.push(this.error);
                this.massEmailErrorCount += 1;
            }
            if (this.massEmail.AdditionalRecipients['bcc'] && !re.test(this.massEmail.AdditionalRecipients.bcc)) {
                this.error = new ErrorList();
                this.error.errorMsg = 'One or more emails in the "BCC:" recipient field is invalid';
                this.error.fieldName = '';
                this.error.fieldRef = null;
                this.errorList.push(this.error);
                this.massEmailErrorCount += 1;
            }
        }
        if (this.errorList.length > 0) {
            const errors = this.errorList.map(e => e.errorMsg);
            if (errors.find(errorString => errorString == 'Select at least one recipient group to whom the email should be sent.')) {
                this.tabChange(0); // Class view tab
            } else if (errors.find(errorString => errorString == 'If BCC is checked, at least one Contact Type must be selected.')) {
                this.tabChange(0); // Class view tab
            } else if (errors.find(errorString => errorString == 'Either select at least one student or click Cancel to abandon the Mass Email process.')) {
                const studentTab = ((this.massEmail.ReferringPage == 'My Classes') ? 'Student View' : 'Students');
                this.tabChange(this.tabNames.indexOf(studentTab)); // Student View tab || Students tab
            } else if (errors.find(errorString => errorString == 'One or more emails in the "To:" recipient field is invalid')) {
                this.tabChange(this.tabNames.indexOf('Additional')); // Additional Tab
            } else if (errors.find(errorString => errorString == 'One or more emails in the "CC:" recipient field is invalid')) {
                this.tabChange(this.tabNames.indexOf('Additional')); // Additional Tab
            } else if (errors.find(errorString => errorString == 'One or more emails in the "BCC:" recipient field is invalid')) {
                this.tabChange(this.tabNames.indexOf('Additional')); // Additional Tab
            } else {
                this.tabChange(0); // Class view tab
            }
        }
        if (this.massEmailErrorCount == 0) {
            this.massEmail.Recipients = [];
            for (let s = 0; s < this.selectedStudents.length; s++) {
                if (this.selectedStudents[s].IsSelected) {
                    const studentSelectedRecipients: Recipient = new Recipient();
                    studentSelectedRecipients.StudentID = this.selectedStudents[s].Id;

                    if (this.loginSettings.V10) {
                        if (this.massEmail.HouseholdRecipientType == 'BCC') {
                            for (let c = 0; c < this.selectedStudents[s].StudentContacts.length; c++) {
                                if (this.selectedContactType.filter(x => x == '(All)').length > 0) {
                                    studentSelectedRecipients.BCC.push(this.selectedStudents[s].StudentContacts[c]);
                                } else if (this.selectedContactType.filter(x => x == '(All Guardians)').length > 0 && this.selectedStudents[s].StudentContacts[c].IsGuardian) {
                                    studentSelectedRecipients.BCC.push(this.selectedStudents[s].StudentContacts[c]);
                                } else if (this.selectedContactType.filter(x => x == '(All Primary Contacts)').length > 0 && this.selectedStudents[s].StudentContacts[c].IsPrimaryParent) {
                                    studentSelectedRecipients.BCC.push(this.selectedStudents[s].StudentContacts[c]);
                                } else if (this.selectedContactType.filter(x => x == '(All Primary Contact who are Guardians)').length > 0 && this.selectedStudents[s].StudentContacts[c].IsGuardian && this.selectedStudents[s].StudentContacts[c].IsPrimaryParent) {
                                    studentSelectedRecipients.BCC.push(this.selectedStudents[s].StudentContacts[c]);
                                } else if (this.selectedContactType.filter(x => x == this.selectedStudents[s].StudentContacts[c].Relationship).length > 0) {
                                    studentSelectedRecipients.BCC.push(this.selectedStudents[s].StudentContacts[c]);
                                }
                            }
                        }
                    } else {
                        for (let c = 0; c < this.selectedStudents[s].StudentContacts.length; c++) {
                            if (this.massEmail.HouseholdRecipientType == 'BCC' && this.selectedStudents[s].StudentContacts[c].Relationship == 'Household Parent') {
                                studentSelectedRecipients.BCC.push(this.selectedStudents[s].StudentContacts[c]);
                            } else if (this.massEmail.NonHouseholdRecipientType == 'BCC' && this.selectedStudents[s].StudentContacts[c].Relationship == 'Non-Resident Parent' && (this.massEmail.IncludeAll == true || this.selectedStudents[s].StudentContacts[c].RequestsMailings == true)) {
                                studentSelectedRecipients.BCC.push(this.selectedStudents[s].StudentContacts[c]);
                            }
                        }
                    }
                    const recipientInfo: StudentContact = new StudentContact();
                    recipientInfo.ID = this.selectedStudents[s].Id;
                    recipientInfo.Email = this.selectedStudents[s].Email;
                    recipientInfo.LastName = this.selectedStudents[s].LastName;
                    recipientInfo.FirstName = this.selectedStudents[s].FirstName;
                    recipientInfo.Relationship = 'Student';
                    recipientInfo.FirstName = this.selectedStudents[s].FirstName;
                    recipientInfo.LastName = this.selectedStudents[s].LastName;
                    if (this.massEmail.StudentRecipientType == 'To' && recipientInfo.Email != '') {
                        studentSelectedRecipients.To.push(recipientInfo);
                    } else if (this.massEmail.StudentRecipientType == 'CC' && recipientInfo.Email != '') {
                        studentSelectedRecipients.CC.push(recipientInfo);
                    } else if (this.massEmail.StudentRecipientType == 'BCC' && recipientInfo.Email != '') {
                        studentSelectedRecipients.BCC.push(recipientInfo);
                    }
                    if (studentSelectedRecipients.To.length == 0 && studentSelectedRecipients.CC.length == 0 && studentSelectedRecipients.BCC.length == 0) {
                        studentsWithoutRecipients.push(this.selectedStudents[s]);
                    }
                    this.massEmail.Recipients.push(studentSelectedRecipients);
                }
            }
            if (this.massEmail.SendEmailToTeachers == true) {
                const classIds = [];
                for (let n = 0; n < this.selectedClasses.length; n++) {
                    if (this.selectedClasses[n].IsSelectedForMassEmail == true) {
                        if (this.loginSettings.V10) {
                            classIds.push(this.selectedClasses[n].SSEC_ID);
                        } else {
                            classIds.push(this.selectedClasses[n].Id);
                        }

                    }
                }
                this.massEmailService.getTeacherRecipientsForMassEmail(classIds).subscribe(results => {
                    for (let t = 0; t < results.length; t++) {
                        if (this.loginSettings.V10) {
                            if (results[t].To == null) {
                                results[t].To = [];
                            }
                            if (results[t].CC == null) {
                                results[t].CC = [];
                            }
                            if (results[t].BCC == null) {
                                results[t].BCC = [];
                            }
                            this.massEmail.Recipients.push(results[t]);
                        }
                        else {
                            const teacherSelectedRecipients: Recipient = new Recipient();
                            teacherSelectedRecipients.StudentID = results[t].StudentID;
                            if (results[t].To == null) {
                                results[t].To = [];
                            } else {
                                results[t].To.forEach(to => {
                                    const recipientInfo: StudentContact = new StudentContact();
                                    recipientInfo.ID = to.ID;
                                    recipientInfo.Email = to.Email;
                                    recipientInfo.LastName = to.LastName;
                                    recipientInfo.FirstName = to.FirstName;
                                    recipientInfo.Relationship = to.Relationship;
                                    teacherSelectedRecipients.To.push(recipientInfo);
                                });
                            }

                            if (results[t].CC == null) {
                                results[t].CC = [];
                            } else {
                                results[t].CC.forEach(cc => {
                                    const recipientInfo: StudentContact = new StudentContact();
                                    recipientInfo.ID = cc.ID;
                                    recipientInfo.Email = cc.Email;
                                    recipientInfo.LastName = cc.LastName;
                                    recipientInfo.FirstName = cc.FirstName;
                                    recipientInfo.Relationship = cc.Relationship;
                                    teacherSelectedRecipients.CC.push(recipientInfo);
                                });
                            }

                            if (results[t].BCC == null) {
                                results[t].BCC = [];
                            } else {
                                results[t].BCC.forEach(bcc => {
                                    const recipientInfo: StudentContact = new StudentContact();
                                    recipientInfo.ID = bcc.ID;
                                    recipientInfo.Email = bcc.Email;
                                    recipientInfo.LastName = bcc.LastName;
                                    recipientInfo.FirstName = bcc.FirstName;
                                    recipientInfo.Relationship = bcc.Relationship;
                                    teacherSelectedRecipients.CC.push(recipientInfo);
                                });
                            }
                            this.massEmail.Recipients.push(teacherSelectedRecipients);
                        }
                    }
                });
            }

            if (this.massEmail.SendEmailToTeamStaffMembers == true) {
                const studentIds = [];
                for (let n = 0; n < this.selectedStudents.length; n++) {
                    if (this.loginSettings.V10) {
                        studentIds.push(this.selectedStudents[n].Id);
                    }
                }
                this.massEmailService.GetTeamStaffMemberRecipientsForMassEmail(studentIds, this.defaultYear.Id, this.defaultYear.SchoolID).subscribe(results => {
                    for (let t = 0; t < results.length; t++) {
                        if (this.loginSettings.V10) {
                            if (results[t].To == null) {
                                results[t].To = [];
                            }
                            if (results[t].CC == null) {
                                results[t].CC = [];
                            }
                            if (results[t].BCC == null) {
                                results[t].BCC = [];
                            }
                            this.massEmail.Recipients.push(results[t]);
                        }
                    }
                });
            }

            if (studentsWithoutRecipients.length > 0) {
                this.noEmailWarningDialogRef = this.dialog.open(NoEmailWarningComponent, {
                    disableClose: true,
                    minWidth: 630,
                    data: studentsWithoutRecipients
                });
                this.noEmailWarningDialogRef.afterClosed().subscribe((retValNoEmailWarning: any) => {
                    if (retValNoEmailWarning == 'Continue was clicked') {
                        this.retValSelectRecipient.massEmail = this.massEmail;
                        this.retValSelectRecipient.Message = 'Continue';
                        this.massEmail.recipientsSelected = true;
                        this.selectRecipientDialogRef.close(this.retValSelectRecipient);
                    }
                });
            } else {
                this.retValSelectRecipient.massEmail = this.massEmail;
                this.retValSelectRecipient.Message = 'Continue';
                this.massEmail.recipientsSelected = true;
                this.selectRecipientDialogRef.close(this.retValSelectRecipient);
            }
        }
    }

    selectedStudentsCheckAllClick() {
        for (let i = 0; i < this.selectedStudents.length; i++) {
            if (this.selectedStudents[i].IsSelected != this.massEmail.selectedStudentsCheckAll) {
                this.selectedStudents[i].IsSelected = this.massEmail.selectedStudentsCheckAll;
                if (this.massEmail.ReferringPage == 'My Classes') {
                    this.selectedStudents[i].SelectedClasses = [];
                    for (let n = 0; n < this.selectedStudents[i].SubjectSections.length; n++) {
                        this.selectedStudents[i].SelectedClasses[this.selectedStudents[i].SubjectSections[n]] = this.massEmail.selectedStudentsCheckAll;
                        if (this.massEmail.selectedStudentsCheckAll == true) {
                            if (this.loginSettings.V10) {
                                const courseObj = this.selectedClasses.find(c => c.SSEC_ID == this.selectedStudents[i].SubjectSections[n]);
                                if (courseObj != null) {
                                    courseObj.IsSelectedForMassEmail = this.massEmail.selectedStudentsCheckAll;
                                }
                            } else {
                                const courseObj = this.selectedClasses.find(c => c.Id == this.selectedStudents[i].SubjectSections[n]);
                                if (courseObj != null) {
                                    courseObj.IsSelectedForMassEmail = this.massEmail.selectedStudentsCheckAll;
                                }
                            }
                        }
                    }
                }
            }
        }
        for (let x = 0; x < this.selectedStudents.length; x++) {
            this.selectedStudents[x].IsSelected = this.massEmail.selectedStudentsCheckAll;
        }
    }

    closeModalClick() {
        this.selectRecipientDialogRef.close('Close Clicked');
    }

    studentClick(student) {
        this.massEmail.selectedStudentsCheckAll = this.selectedStudents.filter(x => x.IsSelected != true) == null;
        if (this.massEmail.ReferringPage == 'My Classes') {
            if (student.IsSelected) {
                for (let i = 0; i < student.SubjectSections.length; i++) {
                    student.SelectedClasses[student.SubjectSections[i]] = true;
                    if (this.loginSettings.V10) {
                        const courseObj = this.selectedClasses.filter(x => x.SSEC_ID == student.SubjectSections[i])[0];
                        courseObj.IsSelectedForMassEmail = true;
                    } else {
                        const courseObj = this.selectedClasses.filter(x => x.Id == student.SubjectSections[i])[0];
                        courseObj.IsSelectedForMassEmail = true;
                    }
                }
            } else {
                for (let i = 0; i < student.SubjectSections.length; i++) {
                    student.SelectedClasses[student.SubjectSections[i]] = false;

                }
            }
        }
        for (let x = 0; x < this.selectedStudents.length; x++) {
            if (this.selectedStudents[x].StudentNumber == student.StudentNumber) {
                this.selectedStudents[x] = student;
            }
        }
    }

    selectedClassesCheckAllClick() {

        for (let i = 0; i < this.selectedClasses.length; i++) {
            if (this.selectedClasses[i].IsSelectedForMassEmail != this.massEmail.selectedClassesCheckAll) {
                this.selectedClasses[i].IsSelectedForMassEmail = this.massEmail.selectedClassesCheckAll;
                this.selectedClasses[i].classStudentsCheckAll = this.massEmail.selectedClassesCheckAll;
            }
        }
        for (let n = 0; n < this.selectedStudents.length; n++) {
            this.selectedStudents[n].IsSelected = this.massEmail.selectedClassesCheckAll;
            for (let x = 0; x < this.selectedStudents[n].SubjectSections.length; x++) {
                this.selectedStudents[n].SelectedClasses[this.selectedStudents[n].SubjectSections[x]] = this.massEmail.selectedClassesCheckAll;
            }
        }
    }

    classClick(course: ClassroomSummary) {
        this.massEmail.selectedClassesCheckAll = false;
        course.classStudentsCheckAll = course.IsSelectedForMassEmail;
        if (course.IsSelectedForMassEmail) {
            for (let i = 0; i < this.selectedStudents.length; i++) {
                if (this.loginSettings.V10) {
                    if (this.selectedStudents[i].SubjectSections.find(x => x == course.SSEC_ID) != null) {
                        this.selectedStudents[i].SelectedClasses[course.SSEC_ID] = true;
                        this.selectedStudents[i].IsSelected = true;
                    }
                } else {
                    if (this.selectedStudents[i].SubjectSections.find(x => x == course.Id) != null) {
                        this.selectedStudents[i].SelectedClasses[course.Id] = true;
                        this.selectedStudents[i].IsSelected = true;
                    }
                }
            }
        } else {
            for (let n = 0; n < this.selectedStudents.length; n++) {
                if (this.loginSettings.V10 && (this.selectedStudents[n].SubjectSections.find(x => x == course.SSEC_ID) != null)) {
                    this.selectedStudents[n].SelectedClasses[course.SSEC_ID] = false;
                } else if (this.selectedStudents[n].SubjectSections.find(x => x == course.Id) != null) {
                    this.selectedStudents[n].SelectedClasses[course.Id] = false;
                }
                let hasClasses = false;
                if (this.selectedStudents[n].SelectedClasses.find(x => x == true) != null) {
                    hasClasses = true;
                }
                this.selectedStudents[n].IsSelected = hasClasses;
            }
        }
        const checkedClassess: ClassroomSummary[] = this.selectedClasses.filter(x => x.IsSelectedForMassEmail == true);
        if (checkedClassess.length == this.selectedClasses.length) {
            this.massEmail.selectedClassesCheckAll = true;
        } else {
            this.massEmail.selectedClassesCheckAll = false;
        }
    }

    selectedTeamsCheckAllClick() {
        for (let i = 0; i < this.selectedStudentTeams.length; i++) {
            if (this.selectedStudentTeams[i].IsSelectedForMassEmail != this.massEmail.selectedTeamsCheckAll) {
                this.selectedStudentTeams[i].IsSelectedForMassEmail = this.massEmail.selectedTeamsCheckAll;
                this.selectedStudentTeams[i].teamStudentsCheckAll = this.massEmail.selectedTeamsCheckAll;
            }
        }
        for (let n = 0; n < this.selectedStudents.length; n++) {
            this.selectedStudents[n].IsSelected = this.massEmail.selectedTeamsCheckAll;
            for (let x = 0; x < this.selectedStudents[n].StudentTeams.length; x++) {
                this.selectedStudents[n].SelectedTeams[this.selectedStudents[n].StudentTeams[x]] = this.massEmail.selectedTeamsCheckAll;
            }
        }
    }

    teamClick(team: StudentTeams) {
        this.massEmail.selectedTeamsCheckAll = false;
        team.teamStudentsCheckAll = team.IsSelectedForMassEmail;
        if (team.IsSelectedForMassEmail) {
            for (let i = 0; i < this.selectedStudents.length; i++) {
                if (this.selectedStudents[i].StudentTeams.find(x => x == team.Id) != null) {
                    this.selectedStudents[i].SelectedTeams[team.Id] = true;
                    this.selectedStudents[i].IsSelected = true;
                }
            }
        } else {
            for (let n = 0; n < this.selectedStudents.length; n++) {
                if (this.selectedStudents[n].StudentTeams.find(x => x == team.Id) != null) {
                    this.selectedStudents[n].SelectedTeams[team.Id] = false;
                }
                let hasTeams = false;
                if (this.selectedStudents[n].SelectedTeams.find(x => x == true) != null) {
                    hasTeams = true;
                }
                this.selectedStudents[n].IsSelected = hasTeams;
            }
        }
        const checkedTeams: StudentTeams[] = this.selectedStudentTeams.filter(x => x.IsSelectedForMassEmail == true);
        if (checkedTeams.length == this.selectedStudentTeams.length) {
            this.massEmail.selectedTeamsCheckAll = true;
        } else {
            this.massEmail.selectedTeamsCheckAll = false;
        }
    }


    selectedListsCheckAllClick() {
        for (let i = 0; i < this.selectedStudentLists.length; i++) {
            if (this.selectedStudentLists[i].IsSelectedForMassEmail != this.massEmail.selectedListsCheckAll) {
                this.selectedStudentLists[i].IsSelectedForMassEmail = this.massEmail.selectedListsCheckAll;
                this.selectedStudentLists[i].listStudentsCheckAll = this.massEmail.selectedListsCheckAll;
            }
        }
        for (let n = 0; n < this.selectedStudents.length; n++) {
            this.selectedStudents[n].IsSelected = this.massEmail.selectedListsCheckAll;
            for (let x = 0; x < this.selectedStudents[n].StudentLists.length; x++) {
                this.selectedStudents[n].SelectedLists[this.selectedStudents[n].StudentLists[x]] = this.massEmail.selectedListsCheckAll;
            }
        }
    }

    listClick(list: StudentList) {
        this.massEmail.selectedListsCheckAll = false;
        list.listStudentsCheckAll = list.IsSelectedForMassEmail;
        if (list.IsSelectedForMassEmail) {
            for (let i = 0; i < this.selectedStudents.length; i++) {
                if (this.selectedStudents[i].StudentLists.find(x => x == list.ID) != null) {
                    this.selectedStudents[i].SelectedLists[list.ID] = true;
                    this.selectedStudents[i].IsSelected = true;
                }
            }
        } else {
            for (let n = 0; n < this.selectedStudents.length; n++) {
                if (this.selectedStudents[n].StudentLists.find(x => x == list.ID) != null) {
                    this.selectedStudents[n].SelectedLists[list.ID] = false;
                }
                let hasLists = false;
                if (this.selectedStudents[n].SelectedLists.find(x => x == true) != null) {
                    hasLists = true;
                }
                this.selectedStudents[n].IsSelected = hasLists;
            }
        }
        const checkedLists: StudentList[] = this.selectedStudentLists.filter(x => x.IsSelectedForMassEmail == true);
        if (checkedLists.length == this.selectedStudentLists.length) {
            this.massEmail.selectedListsCheckAll = true;
        } else {
            this.massEmail.selectedListsCheckAll = false;
        }
    }

    contactTypeClick() {
        this.massEmail.ContactTypes.sort(function (a, b) {
            const labelA = a.label.replace('(', '').replace(')', '');
            const labelB = b.label.replace('(', '').replace(')', '');
            if (a.label == '(All)') {
                return -1;
            }
            if (b.label == '(All)') {
                return 1;
            }
            if (labelA < labelB) {
                return -1;
            }
            if (labelA > labelB) {
                return 1;
            }
            return 0;
        });
        const tmp = [];
        let i = this.massEmail.ContactTypes.length;
        while (i--) {
            if (this.selectedContactType.filter(x => x == this.massEmail.ContactTypes[i].label).length > 0) {
                tmp.push(this.massEmail.ContactTypes[i]);
                this.massEmail.ContactTypes.splice(i, 1);
            }
        }
        for (let x = 0; x < tmp.length; x++) {
            this.massEmail.ContactTypes.splice(0, 0, tmp[x]);
        }
    }

    householdRecipientTypeChanged() {

    }

    tabChange(selectionIndex: number) {
        const tab = this.tabNames[selectionIndex];
        switch (tab) {
            case 'Class View':
                this.massEmail.selectedClassesCheckAll = true;
                for (let i = 0; i < this.selectedClasses.length; i++) {
                    this.selectedClasses[i].classStudentsCheckAll = true;
                    if (!this.selectedClasses[i].IsSelectedForMassEmail) {
                        this.massEmail.selectedClassesCheckAll = false;
                    }
                    for (let s = 0; s < this.selectedStudents.length; s++) {
                        if (this.loginSettings.V10) {
                            const isSSECExists = this.selectedStudents[s].SubjectSections.filter(x => x == this.selectedClasses[i].SSEC_ID);
                            if (isSSECExists != null && isSSECExists.length > 0) {
                                if (this.selectedStudents[s].SelectedClasses[this.selectedClasses[i].SSEC_ID] != true) {
                                    this.selectedClasses[i].classStudentsCheckAll = false;
                                    break;
                                }
                            }
                        } else {
                            const isSSECExists = this.selectedStudents[s].SubjectSections.filter(x => x == this.selectedClasses[i].Id);
                            if (isSSECExists != null && isSSECExists.length > 0) {
                                if (this.selectedStudents[s].SelectedClasses[this.selectedClasses[i].Id] != true) {
                                    this.selectedClasses[i].classStudentsCheckAll = false;
                                    break;
                                }
                            }
                        }
                    }
                }
                break;
            case 'Team View':
                this.massEmail.selectedTeamsCheckAll = true;
                for (let i = 0; i < this.selectedStudentTeams.length; i++) {
                    this.selectedStudentTeams[i].teamStudentsCheckAll = true;
                    if (!this.selectedStudentTeams[i].IsSelectedForMassEmail) {
                        this.massEmail.selectedTeamsCheckAll = false;
                    }
                    for (let s = 0; s < this.selectedStudents.length; s++) {
                        const isTeamExists = this.selectedStudents[s].StudentTeams.filter(x => x == this.selectedStudentTeams[i].Id);
                        if (isTeamExists != null && isTeamExists.length > 0) {
                            if (this.selectedStudents[s].SelectedTeams[this.selectedStudentTeams[i].Id] != true) {
                                this.selectedStudentTeams[i].teamStudentsCheckAll = false;
                                break;
                            }
                        }
                    }
                }
                break;
            case 'List View':
                this.massEmail.selectedListsCheckAll = true;
                for (let i = 0; i < this.selectedStudentLists.length; i++) {
                    this.selectedStudentLists[i].listStudentsCheckAll = true;
                    if (!this.selectedStudentLists[i].IsSelectedForMassEmail) {
                        this.massEmail.selectedListsCheckAll = false;
                    }
                    for (let s = 0; s < this.selectedStudents.length; s++) {
                        const isListExists = this.selectedStudents[s].StudentLists.filter(x => x == this.selectedStudentLists[i].ID);
                        if (isListExists != null && isListExists.length > 0) {
                            if (this.selectedStudents[s].SelectedLists[this.selectedStudentLists[i].ID] != true) {
                                this.selectedStudentLists[i].listStudentsCheckAll = false;
                                break;
                            }
                        }
                    }
                }
                break;
            case 'Student View':
                this.massEmail.selectedStudentsCheckAll = true;
                this.test = this.selectedClasses;
                for (let n = 0; n < this.selectedStudents.length; n++) {
                    if (!this.selectedStudents[n].IsSelected) {
                        this.massEmail.selectedStudentsCheckAll = false;
                        break;
                    }
                }
                break;
        }
        this.tabIndex.emit(selectionIndex);
        this.selectedTab = tab;
        this.loadDataTable();
    }

    toggleExpanded(row: any) {
        if (this.selectedTab == 'Class View') {
            this.classViewDataSource.toggleExpanded(row);
        } else if (this.selectedTab == 'Team View') {
            this.teamViewDataSource.toggleExpanded(row);
        }
        else if (this.selectedTab == 'List View') {
            this.listViewDataSource.toggleExpanded(row);
        }
    }

    checkExpanded(row: any): boolean {
        if (this.selectedTab == 'Class View') {
            return this.classViewDataSource.checkExpanded(row);
        }
        else if (this.selectedTab == 'Team View') {
            return this.teamViewDataSource.checkExpanded(row);
        }
        else if (this.selectedTab == 'List View') {
            return this.listViewDataSource.checkExpanded(row);
        }
        return null;
    }

    nextClick() {
        this.errorList = [];
        this.massEmailErrorCount = 0;
        this.massEmail.Recipients = [];
        const deselectedStudents: string[] = [];
        for (let n = 0; n < this.selectedStudents.length; n++) {
            let hasSelectedClasses = false;
            let hasUnselectedClasses = false;
            if (this.selectedStudents[n].SubjectSections != null) {
                for (let z = 0; z < this.selectedStudents[n].SubjectSections.length; z++) {
                    if (this.selectedStudents[n].SelectedClasses[this.selectedStudents[n].SubjectSections[z]] == true) {
                        hasSelectedClasses = true;
                    } else if (this.selectedStudents[n].SelectedClasses[this.selectedStudents[n].SubjectSections[z]] == false) {
                        hasUnselectedClasses = true;
                    }
                }
            }
            if (hasSelectedClasses == true && hasUnselectedClasses == true) {
                deselectedStudents.push(this.selectedStudents[n].Name);
            }
        }
        if (deselectedStudents.length > 0) {
            this.unselectedWarningDialogRef = this.dialog.open(UnselectedWarningComponent, {
                width: '600px',
                height: '250px',
                disableClose: true,
                data: { object: deselectedStudents }
            });
            this.unselectedWarningDialogRef.afterClosed().subscribe((retValUnselectWarning: any) => {
                if (retValUnselectWarning == 'Continue was clicked') {
                    this.validate();
                }
            });
        } else {
            this.validate();
        }
    }

    cancelClick() {
        this.retValSelectRecipient.Message = 'Cancel';
        this.dialogBox.close();
    }

    expandAll(expand: boolean) {
        if (this.selectedTab == 'Class View') {
            this.classViewDataSource.expandAll(expand);
        }
        else if (this.selectedTab == 'Team View') {
            this.teamViewDataSource.expandAll(expand);
        }
        else if (this.selectedTab == 'List View') {
            this.listViewDataSource.expandAll(expand);
        } else {
            this.studentViewDataSource.expandAll(expand);
        }
    }

    backClick() {
        this.retValSelectRecipient.Message = 'Back';
        this.massEmailService.isBackClick = true;
        this.dialogBox.close();
    }

    resizeGrid() {
        setTimeout(() => {
            this.gridHeight = window.innerHeight - 300;
        }, 0);
    }

    @HostListener('window:resize', ['$event'])
    onResize(event?) {
        this.resizeGrid();
    }

    matTriggerValue() {
        if (this.contactTypes.value.length == this.massEmail.ContactTypes.length) {
            return '(All)';
        } else if (this.contactTypes.value.length > 1) {
            return 'Multiple Selected';
        } else {
            return this.contactTypes.value[0];
        }
    }

    studentClassFilter(subjectSectionIds) {
        return function (course) {
            for (let i = 0; i < subjectSectionIds.length; i++) {
                if ((this.LoginSettings.V10 && subjectSectionIds[i] == course.SSEC_ID) || (!this.LoginSettings.V10 && subjectSectionIds[i] == course.Id)) {
                    return true;
                }
                // return true;
            }
            return false;
        };
    }

    testContactType(obj) {
        this.errorList = [];
        if (this.selectedContactType.length == 0) {
            this.errorList = [];
            this.errorList.push({
                fieldName: null,
                fieldRef: null,
                errorMsg: 'If BCC is checked, at least one Contact Type must be selected.'
            });
        }
        if (obj.label == '(All)') {
            if (this.selectedContactType.indexOf(obj.label) >= 0) {
                this.selectedContactType = [];
                this.massEmail.ContactTypes.forEach(element => {
                    this.selectedContactType.push(element.label);
                });
            } else {
                this.selectedContactType = [];
                this.errorList.push({
                    fieldName: null,
                    fieldRef: null,
                    errorMsg: 'If BCC is checked, at least one Contact Type must be selected.'
                });
            }
        } else {
            if (this.selectedContactType.length != this.massEmail.ContactTypes.length) {
                const idx = this.selectedContactType.indexOf('(All)');
                if (idx >= 0) {
                    this.selectedContactType.splice(idx, 1);
                }
            } else {
                const idx = this.selectedContactType.indexOf('(All)');
                if (idx < 0) {
                    this.selectedContactType.push('(All)');
                }
            }
            this.selectedContactType = _.cloneDeep(this.selectedContactType);
        }
    }

    getStudentInfoForMassEmail() {
        this.massEmailService.getStudentInfoForMassEmail(this.massEmail.StudentIds, this.yearService.defaultYear.Id, this.yearService.defaultYear.SchoolID).subscribe(results => {
            this.massEmail.Students = results;
            this.massEmail.Students.forEach(element => {
                element.IsSelected = true;
            });
            this.massEmail.StudentIds = [];
            this.initialize();
        });
    }

    studentRecipientTypeChange(value: string) {
        if (value != this.massEmail.StudentRecipientType) {
            this.massEmail.StudentRecipientType = value;
            if (this.massEmail.StudentRecipientType) {
                this.massEmail.OneEmailPerHousehold = false;
            }
        }
    }
}
